import React, { Children } from 'react';
import clsx from 'clsx';

// Dummy section for Tailwind CSS
/*
<div className="-translate-x-20 -translate-x-40 -translate-x-60 -translate-x-80"></div>
*/
export const Shove = ({ children }: React.PropsWithChildren) => {
  const normalizedChildren = Children.toArray(children).filter(
    (child) => child,
  );

  const SHOVE_SIZE_FACTOR = 20;

  return (
    <div className="flex overflow-hidden h-full">
      {normalizedChildren.map((child, index) => (
        <div
          key={index}
          className={clsx(
            'transform transition-transform ease-in-out duration-300 h-full',
            normalizedChildren.length > 1 &&
              `-translate-x-${(normalizedChildren.length - 1) * SHOVE_SIZE_FACTOR}`,
          )}
        >
          <div className="border-l border-r border-gray-200 h-full bg-white overflow-y-auto">
            {child}
          </div>
        </div>
      ))}
    </div>
  );
};
